var _rect, _path, _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 35,
    viewBox: "0 0 37 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.285889,
    y: 0.916504,
    width: 36.2182,
    height: 33.2746,
    rx: 4,
    fill: "#393938"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.22109 22.0095L6.99365 28.0291L13.7621 26.8577L28.4563 12.9638L23.1608 8.31079L8.22109 22.0095Z",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.4438,
    cy: 10.1594,
    rx: 2.01212,
    ry: 1.84859,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.a108a6c2fef6c62f1ce5d4b3529db85f.svg";
export { ForwardRef as ReactComponent };